import { cn } from "@newxsystems/shared";
import { KaajImageCarousel } from "../../../../modules/interactive/components";
import { getKaajSectionSpacing } from "../../../../modules/layout/kaaj-section-spacing";
import { RichTextHtml } from "../../RichTextHtml";
import { KaajAction } from "../_shared/KaajAction";
import type { IImageCarouselBlockProps } from "./ImageCarouselBlock.props";

export const ImageCarouselBlock = ({
  anchorId,
  behavior,
  buttons,
  eyebrow,
  heading,
  items = [],
  parentClass,
  spacing,
  subheading,
}: IImageCarouselBlockProps) => {
  const sectionId = anchorId ?? undefined;
  const headingId = heading && sectionId ? `${sectionId}-heading` : undefined;

  if (!eyebrow && !heading && !subheading && !buttons?.length && items.length === 0) {
    return null;
  }

  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "relative isolate overflow-hidden",
        getKaajSectionSpacing(spacing),
        parentClass,
      )}
      data-kaaj-block="imageCarousel"
      id={sectionId ?? undefined}
    >
      <div className="kaaj-container relative">
        {(eyebrow || heading || subheading) && (
          <div className="mb-9 grid gap-6 lg:mb-11 lg:items-end">
            <div className="flex flex-col items-start gap-4 text-left">
              {eyebrow ? (
                <p className="inline-flex max-w-full rounded-full border border-[#CAD7FF] bg-[#EEF2FF] px-3 py-1.5 text-[0.7rem] font-extrabold uppercase leading-none tracking-[0.16em] text-[#2144FF] [overflow-wrap:anywhere]">
                  {eyebrow}
                </p>
              ) : null}
              {heading ? (
                <h2 className="kaaj-section-heading text-[#151927]" id={headingId}>
                  {heading}
                </h2>
              ) : null}
              {subheading ? (
                <RichTextHtml
                  className="text-pretty text-base leading-7 text-[#4B5568] sm:text-lg sm:leading-8"
                  html={subheading}
                />
              ) : null}
            </div>
          </div>
        )}

        <KaajImageCarousel behavior={behavior ?? undefined} items={items} />
        {buttons?.length ? (
          <div className="mt-8 flex flex-wrap gap-3">
            {buttons.map((button, index) => (
              <KaajAction
                ariaLabel={button.ariaLabel}
                href={button.href}
                key={`${button.href}-${button.text}-${index}`}
                label={button.text}
                target={button.target}
                variant={button.style}
              />
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

ImageCarouselBlock.displayName = "Block::ImageCarouselBlock";
